import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'tripnovac_cookie_consent';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(!window.localStorage.getItem(STORAGE_KEY));
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[80] p-4">
      <div className="max-w-3xl mx-auto bg-gray-900 text-white rounded-2xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="text-sm text-gray-200 flex-1">
          We use essential cookies to keep you signed in and measure what we must for the service.
          See our{' '}
          <a href="/privacy" className="underline text-violet-300 hover:text-white">
            Privacy Policy
          </a>{' '}
          and{' '}
          <a href="/terms" className="underline text-violet-300 hover:text-white">
            Terms
          </a>
          .
        </p>
        <button
          type="button"
          onClick={accept}
          className="shrink-0 px-5 py-2.5 rounded-xl bg-violet-600 hover:bg-violet-500 text-sm font-semibold"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
